module.exports = __webpack_public_path__ + "img/plat_4849.74443ac1.jpg";